"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useJoinComponentStates = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _utils = require("../../components/Join/utils");
var _constants = require("../../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Hook to manage the state of the Join component including page navigation, readiness checks, and notifications.
 * @param {Object} params - The parameters for the hook
 * @param {boolean} params.shouldRequireAudio - Whether audio is required for joining
 * @param {Object} params.readinessCheck - Readiness check data
 * @param {string} params.userRole - Role of the user
 * @param {boolean} params.isStandaloneChecker - Whether in standalone checker mode
 * @param {boolean} params.shouldJoinWithoutKnock - Whether to join without knock
 * @returns {Object} Object containing component states including check status, errors, warnings, notifications, and page navigation
 */
var useJoinComponentStates = exports.useJoinComponentStates = function useJoinComponentStates(_ref) {
  var shouldRequireAudio = _ref.shouldRequireAudio,
    readinessCheck = _ref.readinessCheck,
    userRole = _ref.userRole,
    isStandaloneChecker = _ref.isStandaloneChecker,
    shouldJoinWithoutKnock = _ref.shouldJoinWithoutKnock;
  var _useState = (0, _react.useState)(_constants.JOIN_PAGE.SETTINGS),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var data = (0, _react.useMemo)(function () {
    var completedCheckList = (0, _utils.prepareCheckList)(readinessCheck, shouldRequireAudio);
    var errors = (0, _utils.getErrorMessages)(completedCheckList);
    var warnings = (0, _utils.getWarningMessages)(completedCheckList);
    var checkStatus = (0, _utils.getCheckStatus)(completedCheckList, errors);
    var notificationStatus = (0, _utils.getNotificationStatus)(completedCheckList, userRole, isStandaloneChecker, shouldJoinWithoutKnock);
    var notification = _constants.notificationMap[notificationStatus] || {
      message: '',
      linkMessage: ''
    };
    return {
      checkStatus: checkStatus,
      errors: errors,
      warnings: warnings,
      notification: notification
    };
  }, [readinessCheck, shouldRequireAudio, userRole, isStandaloneChecker, shouldJoinWithoutKnock]);
  var checkStatus = data.checkStatus;
  (0, _react.useEffect)(function () {
    if (checkStatus === _constants.JOIN_PAGE_STATUS.BROWSER_BLOCK) {
      setCurrentPage(_constants.JOIN_PAGE.SETTINGS);
    }
  }, [checkStatus]);
  return _objectSpread(_objectSpread({}, data), {}, {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage
  });
};